const AppConfig = {
    appName: 'Helpdesk',
    apiBaseUrl: process.env.REACT_APP_API_URL || '/api',
    freshdeskUrl: process.env.REACT_APP_FRESHDESK_URL || '',
    freshdeskApiKey: process.env.REACT_APP_FRESHDESK_API_KEY || '',
    environment: process.env.NODE_ENV || 'development',
  };
  
  export default AppConfig;
  